import * as cartObject from "@shopify/theme-cart";

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(
        this.dataset.index,
        0,
        "",
        this.dataset.id
      );
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function removeBundleProperties(bundleId, cartContainer) {
  if (!bundleId) return;
  cartObject.getState().then((data) => {
    let bundleItems = data.items.filter((item) => {
      if (item.properties["_click_time"] == bundleId) {
        return item;
      }
    });
    if (bundleItems.length) {
      let propertiesToUpdate = {
        _click_time: false,
        _is_bundle_item: false,
        _bundleHandle: false,
        _products_in_bundle: false,
        _bundlePrice: false,
      };
      cartContainer.cartRecurringUpdate(
        0,
        bundleItems,
        bundleItems[0].quantity,
        propertiesToUpdate
      );
    }
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById("cart__status");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  cartRecurringUpdate = function (index, array, quantity, properties = {}) {
    const body = JSON.stringify({
      id: array[index].key,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    cartObject
      .updateItem(array[index].key, { quantity, properties })
      .then((state) => {
        index = index + 1;
        if (array[index]) {
          this.cartRecurringUpdate(index, array, quantity, properties);
        } else {
          this.reRenderSections(body);
        }
      });
  };

  cartRecurringRemove = function (index, array) {
    const body = JSON.stringify({
      id: array[index].key,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    cartObject.removeItem(array[index].key).then((state) => {
      index = index + 1;
      if (array[index]) {
        this.cartRecurringRemove(index, array);
      } else {
        this.reRenderSections(body);
      }
    });
  };

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.id
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-items-section",
        section: document.getElementById("cart-items-section").dataset.id,
        selector: ".cart__items--wrap",
      },
      {
        id: "cart-total",
        section: document.getElementById("cart-total").dataset.id,
        selector: ".cart__shipping--progress-wrap",
      },
      {
        id: "cart-total",
        section: document.getElementById("cart-total").dataset.id,
        selector: ".totals_mobile",
      },
      {
        id: "cart-total",
        section: document.getElementById("cart-total").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-total",
        section: document.getElementById("cart-total").dataset.id,
        selector: ".cart__total--shipping-text",
      },
    ];
  }

  updateKlarna(cart) {
    const klarnaEls = document.getElementsByTagName("klarna-placement");
    if (!cart && !klarnaEls) return;
    if (klarnaEls.length) {
      klarnaEls.forEach((el) => {
        el.setAttribute("data-purchase-amount", cart.total_price);
      });
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
    }
  }

  updateQuantity(line, quantity, name, id) {
    this.enableLoading(line);

    let key = line.replace(id, id + ":");

    let headerCart = document.querySelector(".header__cart-count");
    let newHeaderCartCount = 0;

    const cartItems = document.querySelectorAll(".quantity__input");
    cartItems.forEach((item) => {
      newHeaderCartCount += parseInt(item.value);
    });
    headerCart.innerHTML = newHeaderCartCount;

    const body = JSON.stringify({
      id: key,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this?.classList?.toggle("is-empty", parsedState.item_count === 0);
        if (parsedState.item_count === 0) {
          document.querySelector("#cart-total").style.display = "none";
        }
        this.getSectionsToRender().forEach((section) => {
          if (
            parsedState.item_count === 0 &&
            section.selector == ".cart__items--wrap"
          ) {
            section.selector = ".cart__section--wrap";
          }
          if (section.selector == ".cart__shipping--progress-wrap") {
            let parsedProgress = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
            document.querySelector(
              `#${section.id} .cart__shipping--progress`
            ).style.width = parsedProgress.querySelector(
              ".cart__shipping--progress"
            ).style.width;
            document.querySelector(
              `#cart-items-section .cart__shipping--progress`
            ).style.width = parsedProgress.querySelector(
              ".cart__shipping--progress"
            ).style.width;
          } else {
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
            if (section.selector == ".cart__total--shipping-text") {
              document.querySelector(
                `#cart-items-section .cart__total--shipping--text`
              ).innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          }
        });

        document
          .getElementById(`CartItem-${line}`)
          ?.querySelector(`[name="${name}"]`)
          ?.focus();
        document
          .querySelector(".cart__items--mobile-switch")
          .addEventListener("click", function (e) {
            this.classList.toggle("active");
            document
              .querySelector(".cart__items--form")
              .classList.toggle("active");
          });
        this.updateKlarna(parsedState);
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay?.classList?.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;
        this.disableLoading();
      });
  }

  getSectionInnerHTML(html, selector) {
    let parsedSection = new DOMParser().parseFromString(html, "text/html");
    if (
      parsedSection.querySelector(".cart__items--mobile-switch") != null &&
      parsedSection.querySelector(".cart__items--form") != null
    ) {
      parsedSection
        .querySelector(".cart__items--mobile-switch")
        .classList.add("active");
      parsedSection.querySelector(".cart__items--form").classList.add("active");
    }
    if (selector == ".cart__shipping--progress-wrap") {
      return parsedSection.querySelector(selector);
    } else {
      return parsedSection.querySelector(selector).innerHTML;
    }
  }

  enableLoading(line) {
    document
      .getElementById("main-cart-items")
      ?.classList?.add("cart__items--disabled");
    this.querySelector(`#loading-overlay-${line}`)?.classList?.remove("hidden");
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    document
      .getElementById("main-cart-items")
      ?.classList?.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

function isEmpty(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return JSON.stringify(obj) === JSON.stringify({});
}

if (document.querySelector(".cart__items--mobile-switch") != null) {
  document
    .querySelector(".cart__items--mobile-switch")
    .addEventListener("click", function (e) {
      this.classList.toggle("active");
      document.querySelector(".cart__items--form").classList.toggle("active");
    });
}
